<template>
	<div>
		<div class="wd-p-20 wd-font-bold wd-font-18">修改密码</div>
		<div class="info wd-flex wd-row-left">
			<div class="wd-m-l-20">
				<el-form label-width="100px">
					<el-form-item label="当前密码:">
						<el-input maxlength="18" type="password" v-model="oldpass"></el-input>
					</el-form-item>
					<el-form-item label="新登录密码:">
						<el-input maxlength="18" type="password" v-model="pass1" minlength="6" placeholder="6-18位字母、数字或符号组合"></el-input>
					</el-form-item>
					<div class="wd-flex wd-row-left level wd-m-t-20 wd-m-b-20">
						<div class="a select">低</div>
						<div class="a">中</div>
						<div class="a">高</div>
					</div>
					<el-form-item label="确认新密码:">
						<el-input maxlength="18" type="password" v-model="pass2"  minlength="6" placeholder="6-18位字母、数字或符号组合"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="save">确定修改</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"Password",
		data(){
			return{
				oldpass:'',
				pass1:'',
				pass2:''
			}
		},
		methods:{
			save(){
				if (this.oldpass==""){
					this.$wd_toast("请输入当前密码","info");
					return;
				}
				if (this.pass1==""){
					this.$wd_toast("请输入新密码","info");
					return;
				}
				if (this.pass1!=this.pass2){
					this.$wd_toast("两次新密码输入不一致");
					return;
				}
				var indata={
					act:"password",
					value:this.pass1,
					value2:this.pass2,
					oldpass:this.oldpass
				}
				this.$wd_request("editmeminfo",indata)
				.then(data=>{
					console.log(data);
					this.$wd_toast(data.msg);
					this.$parent.setflag('Myinfo');
				})
				.catch(data=>{
					this.$wd_toast(data.msg,"error");
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.level {
		margin-left: 100px;
		.a {
			padding: 2px 20px;
			background: #dddddd;
			color: white;
			margin-right: 5px;
			&.select {
				background: #6fa13f;
			}
		}
	}
</style>
